import { render, staticRenderFns } from "./Home1.vue?vue&type=template&id=5c7e133e&scoped=true&"
import script from "./Home1.vue?vue&type=script&lang=js&"
export * from "./Home1.vue?vue&type=script&lang=js&"
import style0 from "./Home1.vue?vue&type=style&index=0&id=5c7e133e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e133e",
  null
  
)

export default component.exports